import { refreshIntervals } from '@/consts/swr'
import { getIndustries } from '@/api/nextme/industries'
import useSWR from 'swr'
import { Industry } from '@/api/interface/industry'

export default function useIndustries(isPublic?: boolean) {
  const {
    data: industries,
    error,
    isValidating,
    mutate,
  } = useSWR(!isPublic ? `/nextme/industries` : null, 
    () => (!isPublic ? getIndustries() : ([] as Industry[])), {
    dedupingInterval: 10000,
    fallbackData: [],
    refreshInterval: refreshIntervals.verySlow,
    revalidateOnFocus: false,
  })

  return {
    error,
    isValidating,
    industries,
    mutateIndustries: mutate,
  }
}
